import React from 'react';

import * as analytics from 'analytics/Analytics';
import {ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';
import {ActionOrigin, COMMON_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import legacyRunModal from 'ui-library/legacyRunModal';

import CreateRequestV2SubmissionModal from '../modals/CreateRequestV2SubmissionModal';

interface CreateRequestV2SubmissionButtonProps {
  isExpanded: boolean;
}

function handleClickNewRequestV2Submission(): void {
  analytics.trackEventWithModule(COMMON_ANALYTICS_ACTIONS.OPENED_MODAL, ANALYTICS_MODULE.REQUESTS, {
    modalType: 'create_request_v2_submission',
    actionOrigin: ActionOrigin.REQUEST_V2_SIDEPANEL,
  });
  legacyRunModal(CreateRequestV2SubmissionModal, {
    actionOrigin: ActionOrigin.REQUEST_V2_SIDEPANEL,
  });
}

export default function CreateRequestV2SubmissionButton(
  props: CreateRequestV2SubmissionButtonProps
): JSX.Element {
  return (
    <Tooltip text={props.isExpanded ? null : 'Create request'} placement={FloatingPlacement.BOTTOM}>
      <Button
        buttonStyle={ButtonStyle.SECONDARY}
        icon="compose"
        onClick={handleClickNewRequestV2Submission}
        size={ButtonSize.SMALL}
        text={props.isExpanded ? 'Create request' : null}
      />
    </Tooltip>
  );
}
